import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=ce0e7488&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=ce0e7488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0e7488",
  null
  
)

export default component.exports